import { Component } from '@angular/core'
import { environment } from '../../../environments/environment'

@Component({
    selector: 'app-tables',
    standalone: true,
    imports: [],
    templateUrl: './tables.component.html',
    styleUrl: './tables.component.css',
})
export class TablesComponent {
    environment = environment
}
